export const selectSize = {
  xs: '1',
  sm: '1/3',
  md: '1/4',
  lg: '1/4',
};
